import React, { useEffect, useState } from 'react';
import './OnPremSiteToSiteVPNRequestsCreate.css';
import RequestFormWrapper from '../common/wrappers/RequestFormWrapper';
import { Alert, Button, Grid, TextLink, TextPassage, Radio, Loader } from 'react-unity';
import { AlertBanner } from '../../models/interfaces/AlertBanner';
import ReactButton from '../common/ReactButton';
import ConfirmModal from '../common/modals/ConfirmModal';
import AlertModal from '../common/modals/AlertModal';
import SelectField from '../common/form-controls/SelectField';
import { useNavigate } from 'react-router-dom';
import OnPremVPNScopeInput from './components/OnPremVPNScopeInput';
import { useAbstractSiteToSiteVPNForm } from './components/AbstractSiteToSiteVPNForm';
import TextInputField from '../common/form-controls/TextInputField';
import SubmitOnPremSiteToSiteVPNRequest from '../../models/viewModels/OnPremSiteToSiteVPNRequests/SubmitOnPremSiteToSiteVPNRequest';
import { Validation } from '../../utils/Validation';
import ExxonMobilSiteToSiteVPNConfigurationForm from './components/siteToSiteVPNConfiguration/ExxonMobilSiteToSiteVPNConfigurationForm';
import ExternalMobilSiteToSiteVPNConfigurationForm from './components/siteToSiteVPNConfiguration/ExternalMobilSiteToSiteVPNConfigurationForm';
import StandardSiteToSiteVPNConfigurationForm from './components/siteToSiteVPNConfiguration/StandardSiteToSiteVPNConfigurationForm';
import OnPremPORSiteToSiteVPNService from '../../services/OnPremPORSiteToSiteVPNService';

const OnPremSiteToSiteVPNRequestsCreate = () => {

    const {
        state,
        formModel,
        getStateFormHandlers,
        handleSubmissionAlertClose,
        setSubmissionAlertInProgress,
        handleEndModal,
        setSubmissionAlertError,
        handleStateFormChange,
        getLinkTree,
        isValid,
        endAndRedirect,
        handleStandardConfigData
    } = useAbstractSiteToSiteVPNForm();
    const stateFormHandler = () => getStateFormHandlers();
    const [loading, setLoading] = useState<boolean>(false);
    const [operationInProgress, setOperationInProgress] = useState<boolean>(false);
    const [loadingTracker, setLoadingTracker] = useState<boolean>(false);
    const [submissionAlert, setSubmissionAlert] = useState<AlertBanner>({ visible: false });
    const [cancelModalVisible, setCancelModalVisible] = useState<boolean>(false);
    const [changeTypeModalVisible, setChangeScopeModalVisible] = useState<boolean>(false);
    const [newScope, setNewScope] = useState<string>(null);
    const navigate = useNavigate();

    const [optionSelected, setOptionSelected] = useState(null);
    const [checkboxOptions, setCheckBoxChecked] = useState([
        { id: 1, label: "Option 1 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH31", value: "Option 1 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH31", method: 1, checked: false },
        { id: 2, label: "Option 2 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH19", value: "Option 2 - IKEv2 with AES-GCM (256-bit)/SHA-512/DH19", method: 2, checked: false },
        { id: 3, label: "Option 3 - IKEv2 with AES-256/SHA-256/DH19", value: "Option 3 - IKEv2 with AES-256/SHA-256/DH19", method: 3, checked: false },
        { id: 4, label: "Option 4 - Exception (with Policy Approval)", value: "Option 4 - Exception (with Policy Approval)", method: 4, checked: false },
    ]);

    const s2svpnService = new OnPremPORSiteToSiteVPNService();

    useEffect(() => {
        initFormModel();
        handleStandardConfigData();
        handleStateFormChange('type', 'NewRequest');
    }, []);

    const initFormModel = () => {
        formModel.fields.trackerID.validation = new Validation({
            required: () => true,
            rules:
                [
                    {
                        assert: () => /^[0-9]*$/.test(state.stateForm.trackerID?.toString() ?? ''),
                        message: 'Only numbers are valid values'
                    },
                    {
                        assert: () => state.stateForm.trackerID >= 10000,
                        message: 'Tracker ID must be grater than 10000'
                    }
                ]
        });
    }

    const handleSubmit = async () => {
        setSubmissionAlert({ visible: true, text: 'Submitting your request...' });
        try {
            const model = formModel.create(SubmitOnPremSiteToSiteVPNRequest);
            console.log('Generated Model:', model);
            const request = await s2svpnService.create(model);
            handleEndModal(
                `Your request was submitted successfully.`,
                'success',
                5000,
                '/onPremSiteToSiteVPN'
            );
        } catch (err) {
            setSubmissionAlertError(err?.response?.data?.message ?? 'An error occured when processing your request. Please, try again later.');
        } finally {
            setOperationInProgress(false);
        }
    };

    const handleCancel = () => {
        setCancelModalVisible(false);
        setOperationInProgress(false);
        navigate('/onPremSiteToSiteVPN');
    };

    const confirmScopeChange = () => {
        handleStateFormChange('direction', null);
        handleStateFormChange('trackerID', null);
        setChangeScopeModalVisible(false);
        setNewScope(null);
    };

    const handleTrackerIdChange = async (event: any) => {
        stateFormHandler().trackerID.onChange(event);
    }

    const handleCheck = (option) => {
        if (option.checked) return;
        setCheckBoxChecked(
            checkboxOptions.map((o) =>
                o.id == option.id ? { ...o, checked: !o.checked } : { ...o, checked: false }
            )
        );
        checkboxOptions.map((o) => {
            o.id == option.id && setOptionSelected(o.method)
        })
    }


    return (
        <>

            <RequestFormWrapper
                title={"New Site to Site VPN Request"}
                linkTree={getLinkTree()}
                loading={loading}
            >
                <p>
                    For more information about Site to Site VPNs {' '}
                    <TextLink className='em-u-margin-right-none' external target="_blank" href='https://goto/POR'>
                        Click here
                    </TextLink>
                </p>
                {submissionAlert.visible &&
                    <Alert
                        variant={submissionAlert.variant}
                        onClose={handleSubmissionAlertClose}
                    >
                        {submissionAlert.text}
                    </Alert>}
                <Grid variant="2-up">
                    <Grid.Item>
                        <OnPremVPNScopeInput
                            direction={stateFormHandler().type}
                        />
                    </Grid.Item>
                    <Grid.Item>
                        <TextInputField
                            label="Third Party Company Name"
                            {...stateFormHandler().companyName}
                            disabled={operationInProgress}
                        />
                    </Grid.Item>
                </Grid>
                <Grid variant="2-up">
                    <Grid.Item>
                        <TextInputField
                            label="Tracker Id"
                            {...stateFormHandler().trackerID}
                            disabled={state.operationInProgress}
                            //scope={state.stateForm?.type}
                            readOnly={state.loadingTracker}
                            onChange={handleTrackerIdChange}
                            note={
                                state.loadingTracker
                                    ? "Validating..."
                                    : state.failedTracker
                                    ? state.errorTracker
                                    : ""
                            }
                        />
                    </Grid.Item>
                    {/* <Grid.Item>
                        <TextInputField
                            label="Work ID"
                            {...stateFormHandler().workID}
                            disabled={operationInProgress}
                        />
                    </Grid.Item> */}
                    <Grid.Item>
                        <SelectField
                            label="Approver"
                            className="full-width"
                            {...stateFormHandler().approver}
                            disabled={state.operationInProgress || stateFormHandler().approver.options.length == 0 || state.loadingTracker}
                            isLoading={stateFormHandler().approver.options.length == 0}
                        />
                    </Grid.Item>
                </Grid>
                <Grid variant="halves">
                    <Grid.Item>
                        <TextPassage>
                            <h3>Section 1: Tunnel End Point Information</h3>
                        </TextPassage>
                    </Grid.Item>
                </Grid>
                <Grid variant="halves">
                    <ExxonMobilSiteToSiteVPNConfigurationForm
                        mode={"create"}
                        {...stateFormHandler().exxonConfiguration}
                        operationInProgress={operationInProgress}
                        readonly={false}
                        isEdit={true}
                        />
                    <ExternalMobilSiteToSiteVPNConfigurationForm
                        mode={"create"}
                        {...stateFormHandler().externalConfiguration}
                        operationInProgress={operationInProgress}
                        readonly={false}
                        isEdit={true}
                    />
                </Grid>
                <TextPassage>
                    <h5>Section 2: ExxonMobil S2S VPN Standard Configuration</h5>
                </TextPassage>
                <Radio.Group label="Default Wired Up List">
                    {checkboxOptions.map(option => (
                        <Radio
                            key={option.id}
                            value={option.id}
                            label={option.label}
                            checked={option.checked}
                            onClick={() => handleCheck(option)}
                        />
                    ))}
                </Radio.Group>

                <Grid variant='halves'>
                    {optionSelected != null &&
                        <StandardSiteToSiteVPNConfigurationForm
                            {...stateFormHandler().standardConfiguration}
                            mode={"create"}
                            optionSelected={optionSelected}
                            standardConfigurationData={state.standardConfigurationData}
                            operationInProgress={operationInProgress}
                        />}
                </Grid>
                <TextPassage>
                    <h5>Section 3: Encryption Domain Information</h5>
                </TextPassage>
                <Grid variant="halves">
                    <Grid.Item>
                        <TextInputField
                            label="ExxonMobil Encryption Domain"
                            {...stateFormHandler().exxonEncrypDomain}
                            disabled={operationInProgress}
                        />
                    </Grid.Item>
                    <Grid.Item>
                        <TextInputField
                            label="External Company Encryption Domain"
                            {...stateFormHandler().externalEncrypDomain}
                            disabled={operationInProgress}
                        />
                    </Grid.Item>
                    <Grid.Item>
                        <TextInputField
                            label="Connected Device Count"
                            {...stateFormHandler().conDeviceCount}
                            disabled={operationInProgress}
                        />
                    </Grid.Item>
                </Grid>
                <Grid variant="4-up">
                    <Grid.Item>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setCancelModalVisible(true);
                                setOperationInProgress(true);
                            }}
                            disabled={operationInProgress}
                        >
                            Cancel Request
                        </Button>
                    </Grid.Item>
                    <Grid.Item />
                    <Grid.Item />
                    <Grid.Item>
                        <ReactButton
                            variant="primary"
                            disabled={!isValid()}
                            isLoading={operationInProgress}
                            handleUpdateSubmit={handleSubmit}
                            loadingVariant="secondary"
                            name="Submit Request"
                        />
                    </Grid.Item>
                </Grid>
            </RequestFormWrapper>
            <ConfirmModal
                visible={cancelModalVisible}
                title='Cancel Request?'
                question="Are you sure you want to cancel this request? This action cannot be undone."
                confirmButton={{
                    label: 'Yes',
                    props: {
                        variant: 'primary',
                        color: 'negative'
                    }
                }}
                cancelButton={{
                    label: 'No',
                }}
                onConfirm={handleCancel}
                onCancel={() => {
                    setCancelModalVisible(false);
                    setOperationInProgress(false);
                }}
            />
            <ConfirmModal
                visible={changeTypeModalVisible}
                title="Change Type"
                question="Are you sure you want to continue? If so, the ruleset will be cleared."
                confirmButton={{
                    label: 'Yes',
                }}
                onConfirm={confirmScopeChange}
                onCancel={() => setChangeScopeModalVisible(false)}
            />
            <AlertModal
                {...state.endModal}
                willTimeout={false}
                onClose={endAndRedirect}
            />
        </>
    );
}

export default OnPremSiteToSiteVPNRequestsCreate;